<template>
  <div>
    <svg-map :map="France" @mouseover="pointLocation" />
  </div>
</template>

<script>
import { SvgMap } from "vue-svg-map";
import France from "@svg-maps/france.departments";
import { getLocationName } from "@/utilities";
import { mapState } from "vuex";

export default {
  components: {
    SvgMap,
  },
  data() {
    return {
      France,
    };
  },
  computed: {
    ...mapState(["pointedLocation"]),
  },
  methods: {
    pointLocation(event) {
      this.$store.state.pointedLocation = getLocationName(event.target);
    },
  },
};
</script>

<style lang="scss">
.svg-map {
  stroke: $primary;
  stroke-width: 0.3px;
}
.svg-map__location {
  fill: $primary;
  cursor: pointer;

  &:focus,
  &:hover {
    opacity: 0.75;
  }
}
</style>
